var QuoteEditView = require('./quote-edit')

module.exports = QuoteEditView.extend()
